import { Box, Divider, Picture } from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { IS_NA, jewlr_t } from "helpers/application"

import {
  Paragraph,
  Section,
  SectionLeft,
  SectionList,
  SectionRight,
  SectionTitle,
} from "./components"
import MainBanner from "./main-banner"
import WhyDropdown from "./why_choose_jewlr/why_choose_jewlr-dropdown"
import getWhyData from "./why_choose_jewlr/why_choose_jewlr-links"

const ListLink = styled(Link)`
  color: ${(props) => props.theme.colors.primary};
  font-size: 14px;
  font-weight: 300;
  ${(props) => props.theme.mediaQueries.tablet`
    font-size: 16px;
  `}
`
const WhyChooseJewlr = () => {
  const whyData = getWhyData()
  return (
    <>
      <MainBanner alt="Why Choose Jewlr" src="why_jewlr" />
      <Box contain px={{ _: "10px", tablet: 2 }}>
        <Section>
          <SectionLeft>
            <SectionTitle>
              {jewlr_t("terms.Jewelry")} That Shows How You Feel
            </SectionTitle>
          </SectionLeft>
          <SectionRight>
            <Paragraph>
              Have you ever created your own {jewlr_t("terms.personalized")}{" "}
              {jewlr_t("terms.jewelry")}? It makes giving so much more real when
              you actually chose every part of the piece you’re giving to that
              special someone. Then you can say that it truly came from the
              heart.
            </Paragraph>
            <Paragraph>
              We know that you’re not buying just a piece of{" "}
              {jewlr_t("terms.jewelry")} – you’re trying to put how you feel
              into something that goes beyond words. That’s why you need
              something completely unique. Something that no one else has ever
              received. A One in a million gift.
            </Paragraph>
            <Paragraph>
              With a {jewlr_t("terms.personalized")} piece, you will combine
              stones, metal and engravings of any color and style you desire.
              Choose birthstones to represent loved ones, or pick their favorite
              stone. Decide on a style and metal to match their taste and your
              budget. Preserve memorable dates, precious names or special
              messages.
            </Paragraph>
          </SectionRight>
        </Section>

        <Divider bg="grey.10" my={3} />
        <Box>
          <Paragraph px={4}>
            &quot;We know that you’re not buying just a piece of{" "}
            {jewlr_t("terms.jewelry")} – you’re trying to put how you feel into
            something that goes beyond words.&quot;
          </Paragraph>
        </Box>

        <Divider bg="grey.10" my={3} />
        <Section>
          <Box px={4} width={{ tablet: 5 / 10 }}>
            <Picture
              alt="Instant Gift"
              srcSet={[
                {
                  height: "210",
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `${require("images/info/why_jewlr/whychoose2_mobile.jpg")} 430w`,
                  width: "430",
                },
                {
                  height: "635",
                  media: "(min-width: 768px)",
                  sizes: "330px",
                  srcSet: `${require("images/info/why_jewlr/whychoose2.jpg")} 480w, ${require("images/info/why_jewlr/whychoose2_2x.jpg")} 728w`,
                  width: "480",
                },
              ]}
            />
          </Box>

          <Box pl={0} width={{ tablet: 5 / 10 }}>
            <SectionTitle textAlign="left">Why Choose Jewlr</SectionTitle>
            <Paragraph>
              We believe that to succeed as a leading online{" "}
              {jewlr_t("terms.jewelry")} store, we have to give our customers
              what they are looking for:
            </Paragraph>
            <Box>
              <SectionList lineHeight={{ _: "1.5", tablet: "26px" }}>
                <li>Great value on quality items</li>
                <li> Great customer service</li>
                <li> Great product variety and choice </li>
                <li>
                  {" "}
                  Easy risk-free shopping experience, fast and free{" "}
                  {jewlr_t("terms.shipping")}{" "}
                </li>
              </SectionList>
            </Box>
            <Box>
              <Paragraph>
                We are able to deliver on these desirables by creating a unique
                store built on the latest technology and innovative
                manufacturing. We can guarantee that our prices are the lowest
                because we do not have the overhead of a brick and mortar retail
                store. Our innovative order management process ensures that we
                do not have to warehouse or hold costly inventory. Our customer
                service department uses advanced messaging and live
                communication tools to ensure that we are able to respond to our
                customers as soon as practical.
              </Paragraph>
            </Box>
            <Divider bg="grey.10" my={3} />
            <Box>
              <SectionTitle textAlign="left">
                Included with every order
              </SectionTitle>
            </Box>
            <Box>
              <SectionList lineHeight={{ _: "1.5", tablet: "26px" }}>
                <li>
                  <ListLink
                    data-lc="why-choose-jewlr"
                    to="/info/shipping_information"
                  >
                    FREE {jewlr_t("terms.shipping")}
                  </ListLink>{" "}
                  to all locations in the USA, Canada, United Kingdom and
                  Australia
                </li>
                {IS_NA() && (
                  <li>
                    <ListLink data-lc="why-choose-jewlr" to="/info/ring_sizing">
                      FREE resizing
                    </ListLink>{" "}
                    on almost all of our rings
                  </li>
                )}
                <li> Certificate of Authenticity </li>
                <li>
                  <ListLink data-lc="why-choose-jewlr" to="/info/packaging">
                    Packaged
                  </ListLink>{" "}
                  for gifting
                </li>
                <li> {jewlr_t("terms.Jewelry")} Care Tips </li>
              </SectionList>
            </Box>
          </Box>
        </Section>
        <Divider bg="grey.10" my={3} />
        <Box mt={3}>
          <SectionTitle textAlign="left">
            Top 5 reasons to shop at Jewlr
          </SectionTitle>
          <Paragraph>
            Nothing says it like {jewlr_t("terms.personalized")}{" "}
            {jewlr_t("terms.jewelry")}. And there is no place better than Jewlr
            to get it made, for these 5 simple reasons:
          </Paragraph>
          {whyData.map((whyCategory, i) => (
            <WhyDropdown index={i} key={`why${i}`} whyCategory={whyCategory} />
          ))}
        </Box>
      </Box>
    </>
  )
}

export default WhyChooseJewlr
